import { gql } from "@apollo/client";

export const GetFreshnessMeter = gql`query GetFreshnessMeter($filters: FreshnessMeterFilter!) {
    getFreshnessMeter(filters: $filters) {
      explanation
      freshness
      product
      score
      locationName
      latitude
      longitude
    }
  }
`

export const GetConsumerMappedForm = gql`
query GetConsumerMappedFormBasedOnOrgid($filters: ConsumerMappedFormInput!) {
  getConsumerMappedFormBasedOnOrgid(filters: $filters) {
    id
    formName
    formFields
  }
}`



export const GetPresignedUrlforConsumerEngagement = gql`
query GetPresignedUrlForConsumerEngagmentPutObject($imageInput: GetPresignedUrlForConsumerEngagementInput!) {
  getPresignedUrlForConsumerEngagmentPutObject(imageInput: $imageInput) {
    fileName,
    presignedUrl
  }
}
`

export const VerifyOtp = gql`query VerifyOtp($filters: OtpRequestInput!) {
  verifyOtp(filters: $filters) {
    message
    id
    exists
  }
}`

export const TracePreSignedUrl = gql`query TracePreSignedUrl($filter: TraceUrlFilter!) {
  tracePreSignedUrl(filter: $filter) {
    url
  }
}`

export const GetEventCaptureFormInput = gql`query TraceEventCaptureFormInput($filters: EpcisEventFormFilter!) {
  traceEventCaptureFormInput(filters: $filters) {
    formData
  }
}`

export const GetBatchTraceItem = gql`query GetBatchTraceItem($filters: OrgProductBatchTraceInput!) {
  getBatchTraceItem(filters: $filters) {
  traceItemId  
  }
}`
// Recent API's
export const TraceEventDetailsV2 = gql`query TraceEventDetails($filters: TraceFilter!) {
  traceEventDetails(filters: $filters) {
    traceDetails {
      eventId
      entityName
      eventDescription
      eventType
      eventDefId
      formDetails
      eventStartDate
      eventStartUnixEpoch
      eventEndDate
      eventEndUnixEpoch
      eventTimeZoneOffset
      inputProductInstances
      outputProductInstances
      latitude
      longitude
      userEvent
      locationName
      eventAccess
    }
  }
}`

export const getOrgDetails = gql`
query TraceOrgProductDetails($filters: OrgProductTraceInput!) {
  traceOrgProductDetails(filters: $filters) {
    lotBatchLabel
    lotBatchLabelDesc
    orgDetails {
      shortName
      storyLine
      tagLine
      companyWebsite
      organizationCertificates
      viewerOptions
      defaultViewer
      logoPresignedUrl
      bannerPresignedUrl
      organizationCertificates
      isCustomTracePage
    }
  }
}
`

export const TraceProductInfo = gql`query TraceProductInfo($input: EventProductInstancesInput!) {
  traceProductInfo(input: $input) {
    traceProducts {
      productInfoList {
        displayName
        description
        productId
        productFileType
        productOwningGln
        productInstanceId
      }
      eventId
    }
  }
}
`

export const TraceEventImages = gql`
query TraceEventImages($input: TraceInput!) {
  traceEventImages(input: $input) {
    traceProducts {
      eventId
      eventImageInfoList {
        instanceId
        presignedUrl
      }
    }
  }
}
`

export const TraceProductImages = gql`query TraceProductImages($input: EventProductInstancesInput!) {
  traceProductImages(input: $input) {
    traceProductImages {
      eventId
      instances {
        instanceId
        productImageInfoList {
          instanceId
          presignedUrl
          productId
        }
      }
    }
  }
}
`

export const TraceLocationCertificates = gql`
query TraceLocationCertificates($input: TraceInput!) {
  traceLocationCertificates(input: $input) {
    locationCertInfo {
      eventId
      locationCertificates
    }
  }
}
`

export const TraceProductCertificates = gql`query TraceProductCertificates($input: EventProductInstancesInput!) {
  traceProductCertificates(input: $input) {
    productCertInfo {
      eventId
      instanceId
      productCertificates
    }
  }
}
`

export const GetConsumerEngagementForTrace = gql`
query GetConsumerEngagementForTrace($consumerEngInput: ConsumerEngForTraceInput!) {
  getConsumerEngagementForTrace(consumerEngInput: $consumerEngInput) {
    id
    engagementName
    orgId
    startDate
    endDate
    isActive
    formId
    feedbackMethod
    authMethod
    authType
    commentsFiled
    isDeprecated
    submissionDisplayMessage
    action
    actionDestination
    region {
      engagementImage
      engagementMessage
    }
    createdBy
  }
}
`
export const TraceEventEntityInstances = gql`
query TraceEventEntityInstances($input: EventEntityInstancesInput!) {
  traceEventEntityInstances(input: $input) {
    eventId
    totalCount
    instances {
      entityGroup
      entityId
      entityName
      entityType
    }
  }
}
`